'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

import FilterDropdown from './FilterDropdown';

import AssociationTerm from './AssociationTerm';
import AssociationEvidence from './AssociationEvidence';
import getKey from '../assocKey';

import variables from '../sass/_variables.scss';

var AssociationsView = function (_React$Component) {
  _inherits(AssociationsView, _React$Component);

  function AssociationsView() {
    var _temp, _this, _ret;

    _classCallCheck(this, AssociationsView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      filters: _this.props.filters
    }, _this.filterHandler = function (filter, selected) {
      if (filter == "all") {
        var temp = new Map(_this.state.filters);
        temp.forEach(function (val, key) {
          temp.set(key, selected);
        });
        _this.setState({ filters: temp });
      } else {
        var temp = new Map(_this.state.filters);
        temp.set(filter, selected);
        _this.setState({ filters: temp });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  AssociationsView.prototype.render = function render() {
    var _this2 = this;

    // console.log("AssocView: start");
    var _props = this.props,
        blocks = _props.blocks,
        config = _props.config,
        currentblock = _props.currentblock,
        filters = _props.filters,
        focalblock = _props.focalblock,
        provided_list = _props.provided_list;

    var assoc_list = [];
    if (provided_list) {
      assoc_list = provided_list;
    } else {
      blocks.forEach(function (slimitem) {
        if (slimitem.class_id === currentblock.class_id) {
          assoc_list = slimitem.uniqueAssocs;
        }
      });
    }

    // console.log("AssocView -- List: ", assoc_list);

    var shown = 0;

    return React.createElement(
      'div',
      { className: 'ontology-ribbon__assoc' },
      React.createElement(
        'div',
        { className: 'ontology-ribbon__headline ' + (this.props.borderBottom ? 'ontology-ribbon__headline--border-bottom' : '') },
        this.props.tableLabel
      ),
      React.createElement(
        'div',
        { className: 'ontology-ribbon__header ' + (this.props.borderBottom ? 'ontology-ribbon__header--border-bottom' : '') },
        React.createElement(
          'div',
          { style: { fontWeight: 'bold', width: '50%' } },
          'Term'
        ),
        React.createElement(FilterDropdown, { filters: this.state.filters, filterHandler: this.filterHandler, counts: this.state.counts }),
        React.createElement(
          'div',
          { style: { fontWeight: 'bold', width: '20%' } },
          'With/From'
        ),
        React.createElement(
          'div',
          { style: { fontWeight: 'bold', width: '20%' } },
          'Reference'
        )
      ),
      assoc_list.map(function (assoc, index) {
        var row_style;
        var focus = false;
        if (focalblock && focalblock.uniqueIDs) {
          focus = focalblock.uniqueIDs.includes(getKey(assoc));
        }
        if (focus) {
          row_style = {
            borderLeftStyle: 'solid',
            borderLeftWidth: 'thick',
            borderLeftColor: variables.secondary_color,
            fontStyle: 'italic'
          };
        } else {
          row_style = {};
        }

        var e_map = assoc.evidence_map;
        var e_types = [];
        var temp = void 0;
        e_map.forEach(function (val, key) {
          temp = val.map(function (elt) {
            return elt.evidence_type;
          });
          temp.forEach(function (elt) {
            e_types.push(elt);
          });
        });

        var found = false;
        e_types.forEach(function (type) {
          if (_this2.state.filters.get(type)) {
            found = true;
          }
        });

        if (found) {
          shown++;
          return React.createElement(
            'div',
            { className: 'ontology-ribbon__assoc__row' + (_this2.props.oddEvenColor ? shown % 2 == 0 ? ' ontology-ribbon__assoc__row--even' : ' ontology-ribbon__assoc__row--odd' : '') + (_this2.props.borderBottom ? ' ontology-ribbon__assoc__row--border-bottom' : ''),
              key: index, style: row_style },
            React.createElement(
              'div',
              { className: 'ontology-ribbon__term-column', key: 'term' + index },
              React.createElement(AssociationTerm, { assoc: assoc, config: config, row: index, termURL: _this2.props.termURL, termInNewPage: _this2.props.termInNewPage })
            ),
            React.createElement(
              'div',
              { className: 'ontology-ribbon__evidence-column', key: 'evidence' + index },
              React.createElement(AssociationEvidence, { assoc: assoc, filters: _this2.state.filters, row: index })
            )
          );
        } else {
          return null;
        }
      })
    );
  };

  return AssociationsView;
}(React.Component);

export { AssociationsView as default };


AssociationsView.propTypes = process.env.NODE_ENV !== "production" ? {
  blocks: PropTypes.arrayOf(PropTypes.shape({
    class_id: PropTypes.string
  })),
  config: PropTypes.object,
  currentblock: PropTypes.object,
  filters: PropTypes.object,
  focalblock: PropTypes.object,
  tableLabel: PropTypes.string,
  oddEvenColor: PropTypes.bool,
  borderBottom: PropTypes.bool,
  termURL: PropTypes.string,
  termInNewPage: PropTypes.bool
} : {};

AssociationsView.defaultProps = {
  tableLabel: "GO Annotations",
  oddEvenColor: false,
  borderBottom: false
};